import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import './SingleSelectDropdown.css';

interface Option {
    label: string;
    value: string;
}

interface SingleSelectDropdownProps {
    label: string;
    options: Option[];
    value: string;
    onChange: (value: string) => void;
}

export function SingleSelectDropdown({ label, options, value, onChange }: SingleSelectDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (optionValue: string) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    const selectedOption = options.find(o => o.value === value) || options[0];

    return (
        <div className="single-select-container" ref={dropdownRef}>
            <span className="single-select-label-text">{label}:</span>
            <div className="single-select-dropdown" onClick={() => setIsOpen(!isOpen)}>
                <div className={`single-select-trigger ${isOpen ? 'active' : ''}`}>
                    <span className="single-select-text">{selectedOption ? selectedOption.label : value}</span>
                    <FontAwesomeIcon icon={faChevronDown} className={`chevron-icon ${isOpen ? 'open' : ''}`} />
                </div>
                {isOpen && (
                    <div className="single-select-options">
                        {options.map(option => (
                            <div
                                key={option.value}
                                className={`single-select-option ${value === option.value ? 'selected' : ''}`}
                                onClick={(e) => { e.stopPropagation(); handleSelect(option.value); }}
                            >
                                <span>{option.label}</span>
                                {value === option.value && (
                                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SingleSelectDropdown;
